import { useTranslate, Col, Typography } from "@commonlibs";
import { FileUploadRoot, UploadSection } from "ui/transaction/container/CustomerManagementModal/CustomerManagementModal.styles";
import Excel from "../../../../assets/icons/filled/Excel.svg";

export enum FileUploadStatus {
    INITIAL = 'INITIAL',
    LOADING = 'LOADING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
}

export interface FileUploadSectionProps {
    fileUploadedStatus: FileUploadStatus;
    uploadMessage: React.ReactNode;
    onUpload: (file: File) => Promise<string>;
    icon?: React.ReactNode;
    uploadText?: string;
    size?: 'xs' | 'sm' | 'md';
    fullWidth?: boolean;
    fileTypes?: string;
}

const FileUploadArea: React.FC<FileUploadSectionProps> = ({
    fileUploadedStatus,
    uploadMessage,
    onUpload,
    icon,
    uploadText,
    size = 'xs',
    fullWidth = true,
    fileTypes,
}) => {
    const translate = useTranslate();
    const defaultIcon = <img width={45} src={Excel} alt="Upload file" />;
    const defaultText = uploadText || translate('uploadFileText');

    return (
        <UploadSection>
            {fileUploadedStatus !== FileUploadStatus.INITIAL ? (
                uploadMessage
            ) : (
                <FileUploadRoot
                    upload={onUpload}
                    fileTypes={fileTypes}
                    placeholder={
                        <Col alignItems="center" gap={8}>
                            {icon || defaultIcon}
                            <Typography variant="body3Strong">
                                {defaultText}
                            </Typography>
                        </Col>
                    }
                    size={size}
                    fullWidth={fullWidth}
                    keepPlaceholder
                />
            )}
        </UploadSection>
    );
};

export default FileUploadArea;